var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.webVIewValidation() && !_vm.loading)?[_c(_vm.layout,{tag:"component"})]:_vm._e(),(_vm.loading)?_c('Loader'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }